export default __webpack_public_path__ + "media/images/dashed-bfd1bbdf3e88b7e667c5eacd115c965a.svg";